<template>
    <!-- Primary Navigation
            ============================================= -->
    <nav id="primary-menu" class="with-arrows style-2 center">

        <div class="container clearfix">

            <div id="primary-menu-trigger"><i class="icon-reorder"></i></div>

            <ul>
                <li v-if="currentUser">
                    <a href="javascript:" @click="goHome()">
                        <div>Home</div>
                    </a>
                </li>
                <li v-for="menu in menuItems">
                    <a :href="menu.url" v-if="!menu.isRouterLink">
                        <div>{{menu.name}}</div>
                    </a>
                    <router-link :to="menu.url" v-if="menu.isRouterLink" active-class="current">
                        <div>{{menu.name}}</div>
                    </router-link>
                </li>
                <li v-if="currentUser">
                    <a href="#" @click="logout()">
                        <div>Logout</div>
                    </a>
                </li>
            </ul>

        </div>

    </nav><!-- #primary-menu end -->
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import {goHome} from '@/utils'

    export default {
        name: 'MainMenu',
        methods: {
            ...mapActions(['logout']),
            goHome: goHome
        },
        computed: {
            ...mapGetters(['currentUser']),
            menuItems () {
                let menu = []
                if (this.currentUser) {
                    for (const [key, value] of Object.entries(this.currentUser.user_types)) {
                        menu.push({
                            name: value.menu_name,
                            isRouterLink: true,
                            url: value.router_link
                        })
                    }
                }
                return menu
            }
        }
    }
</script>

<style scoped>
    .router-link-exact-active {
        color: #4586C6
    }

    .router-link-active {
        color: #4586C6
    }
</style>
